<template>
  <span v-if="pricingType == 'per_item'" class="text-paragraph-2 text-gray-1 inline-block">
    <span v-if="availabilityType == 'daily' || availabilityType == 'nightly'">
      / {{ $t(availabilityType) }}
    </span>
    <span v-if="availabilityType == 'per_time'">
      / {{ calculateDuration }}
    </span>
  </span>
  <span
    v-else-if="pricingType == 'per_person'"
    class="text-paragraph-2 text-gray-1 inline-block"
  >
    / {{ $t("per_person") }}
  </span>
</template>

<script setup lang="ts">
const { t } = useI18n();
const props = defineProps({
  pricingType: {
    type: String,
    default: null,
  },
  availabilityType: {
    type: String,
    default: null,
  },
  duration: {
    type: Number,
    default: null,
  },
});

const calculateDuration = computed(() => {
  if (!props.duration) return "";

  const duration = props.duration;
  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;

  let result = "";
  if (hours == 1 && minutes == 0) {
    result = `${t("hour")}`;
  } else {
    if (hours > 0) result += `${hours} ${t("hr")}`;
    if (minutes > 0) result += `${hours > 0 ? " " : ""}${minutes} ${t("min")}`;
  }

  return result;
});
</script>
